import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Container,
  Divider,
  Heading,
  HStack,
  Icon,
  Image,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { FaRegCirclePlay } from "react-icons/fa6";
import { RiCalendarTodoFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Logo from "../../../assets/colorLogo.png";
import Layout from "../../../components/student/Layout/layout";
import ExamCourse from "../../../containers/student/course-flow/exam-course";
import VideoCourse from "../../../containers/student/course-flow/video-course";
import AddVoucher from "../../../containers/student/models/add-voucher";
import SolveHomework from "../../../containers/student/models/solve-homework";
import { openSolveHomeworkModel } from "../../../modules/admin-modules/models/Actions";
import { getStudentChapterRequest } from "../../../modules/students-modules/chapters/Actions";
import { getExamsByChapterIdRequest } from "../../../modules/students-modules/exams/Actions";
import { getHomeworksByChapterIdRequest } from "../../../modules/students-modules/homework/Actions";
import { getLessonsByChapterIdRequest } from "../../../modules/students-modules/lessons/Actions";
import { getLastLiveVideoRequest } from "../../../modules/students-modules/live-videos/Actions";
import { getVideosByChapterIdRequest } from "../../../modules/students-modules/videos/Actions";

const ChapterDetails = (props) => {
  const [selectedData, setSelectedData] = useState({});

  const { id, type } = useParams();
  const dispatch = useDispatch();
  const chapterVideos = useSelector(
    (state) => state.chapterVideos.chapterVideos
  );
  const chapterExams = useSelector((state) => state.chapterExams.chapterExams);
  const homeworks = useSelector(
    (state) => state.studentHomework.chapterHomeworks
  );

  const lessons = useSelector((state) => state.chapterLessons.chapterLessons);

  const { lastLiveVideo } = useSelector((state) => state.studentLiveVideos);

  const { chapter, isLoading } = useSelector((state) => state.studentChapters);

  const baseUrl = "https://api.agwad.net";

  useEffect(() => {
    if (id) {
      dispatch(getStudentChapterRequest(id));
    }
  }, [id]);

  useEffect(() => {
    if (type == "video") {
      dispatch(getVideosByChapterIdRequest(id));
    }
    if (type == "exam") {
      dispatch(getExamsByChapterIdRequest(id));
    }
    if (type == "pdf") {
      dispatch(getLessonsByChapterIdRequest(id));
    }
    if (type == "livevideos") {
      dispatch(getLastLiveVideoRequest());
    }
    if (type == "homework") {
      dispatch(getHomeworksByChapterIdRequest(id));
    }
  }, [id, type]);

  const unit = {
    video: {
      label: "Videos",
      count: chapterVideos?.length,
      data: chapterVideos,
    },
    pdf: {
      label: "PDFs",
      count: lessons?.length,
      data: lessons,
    },
    exam: { label: "Exams", count: chapterExams?.length, data: chapterExams },
    homework: {
      label: "Homeworks",
      count: homeworks?.length,
      data: homeworks,
    },

    livevideos: {
      label: "Live Videos",
      count: lastLiveVideo ? 1 : 0,
      data: lastLiveVideo,
    },
  };

  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.2xl" h="100%" my="100px" mb="165px" w="100%">
        <VStack spacing={8} h="100%" w="100%" alignItems="flex-start" mt={20}>
          <HStack bg="main_1" h="300px" w="100%" p="20px">
            <Heading as="h3" color="white" w="100%" textTransform="capitalize">
              {chapter?.name}
            </Heading>
            <Stack
              bg="white"
              borderRadius="16px"
              w="400px"
              p={2}
              shadow="lg"
              mt="100px !important"
            >
              <Image src={Logo} borderTopRadius="lg" w="100%" />

              <Stack px={4} gap={2} pb={4} pt={2}>
                {chapterVideos?.[0]?.chapter?.restrict != 0 ? null : (
                  <Button bg="main_1" color="white">
                    Buy Now
                  </Button>
                )}
                <Divider w="100%" colorScheme="green" h="1px" bg="#0100381c" />

                <HStack alignItems="center" gap={1}>
                  <FaRegCirclePlay color="#8196df" size={20} />{" "}
                  <Text>
                    {unit?.[type]?.count} {unit?.[type]?.label}
                  </Text>
                </HStack>
              </Stack>
            </Stack>
          </HStack>

          <Accordion
            defaultIndex={[0]}
            allowMultiple
            w="80%"
            mt="120px !important"
          >
            <AccordionItem border={0} my={10}>
              <h2>
                <AccordionButton bg="gray.200" borderRadius="15px">
                  <Box
                    as="p"
                    flex="1"
                    fontSize="20px"
                    fontWeight="600"
                    textAlign="left"
                    p={2}
                  >
                    Lesson Content
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>

              {unit?.[type]?.data?.map((data, idx) => {
                return (
                  <AccordionPanel pb={4}>
                    {type === "homework" && (
                      <VStack
                        alignItems="flex-start"
                        border="1px solid #eee"
                        p={4}
                        borderRadius={5}
                        cursor="pointer"
                      >
                        <Text
                          fontSize="18px"
                          textTransform="capitalize"
                          fontWeight="500"
                        >
                          {data?.name}{" "}
                          <span
                            style={{ fontSize: "14px", marginInline: "4px" }}
                          >
                            (pdf homework)
                          </span>
                        </Text>

                        <HStack spacing="8px">
                          <Icon as={RiCalendarTodoFill} />
                          <Text>
                            {dayjs(data?.created_at).format("D , MMM ,YYYY")}
                          </Text>
                        </HStack>
                        <Button
                          alignSelf="end"
                          onClick={() => {
                            if (data?.file) {
                              window.open(
                                `https://docs.google.com/gview?url=${data?.file}`,
                                "_blank"
                              );
                            } else {
                              setSelectedData(data);
                              dispatch(openSolveHomeworkModel());
                            }
                          }}
                        >
                          {data?.is_solved == 1 ? "Preview" : "Solve"}
                        </Button>
                      </VStack>
                    )}
                    {type === "exam" && <ExamCourse exam={data} />}
                    {type === "video" && (
                      <VideoCourse
                        video={data}
                        setSelectedData={setSelectedData}
                      />
                    )}
                    {type === "pdf" && (
                      <VStack
                        alignItems="flex-start"
                        border="1px solid #eee"
                        p={4}
                        borderRadius={5}
                        w="100%"
                        spacing={4}
                      >
                        <VStack alignItems="flex-start" w="100%" spacing={2}>
                          <Text
                            fontSize="18px"
                            textTransform="capitalize"
                            fontWeight="500"
                          >
                            {data?.title || data?.name}
                          </Text>
                          {data?.description && (
                            <Text fontSize="14px" color="gray.600">
                              {data?.description}
                            </Text>
                          )}
                        </VStack>
                        <Button
                          alignSelf="end"
                          bg="main_1"
                          color="white"
                          _hover={{ bg: "main_1", opacity: 0.9 }}
                          onClick={() => {
                            if (data?.file_path) {
                              window.open(
                                `${baseUrl}/${data?.file_path}`,
                                "_blank"
                              );
                            }
                          }}
                        >
                          Preview
                        </Button>
                      </VStack>
                    )}
                  </AccordionPanel>
                );
              })}
            </AccordionItem>
            <AccordionItem border={0}>
              <h2>
                <AccordionButton bg="gray.200" borderRadius="15px">
                  <Box
                    as="p"
                    flex="1"
                    fontSize="20px"
                    fontWeight="600"
                    textAlign="left"
                    p={2}
                  >
                    Lesson Description
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Text fontSize="20px">{selectedData?.over_view} </Text>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </VStack>
      </Container>
      <AddVoucher video_id={selectedData?.id} />
      <SolveHomework data={selectedData} setSelectedData={setSelectedData} />
    </Layout>
  );
};

export default ChapterDetails;
